import Data from "../assets/scripts/base/Data";
import * as Utils from "../assets/scripts/utils";
import { message } from "antd";
import Config from "../config";

const MOCK = Config.MOCK;

const error = Utils.debounce(message.error);

export const create = (config, Service, mock) => {
    config.map(
        val =>
        (Service[val[0]] = async (params, form) => {

            // 接口是否开发完毕
            const success = val[3];
            const apiRoot = val[4];

            if (MOCK && !success) return mock[val[0]]();

            const type = val[2];
            const url = (apiRoot || Config.apiRoot) + val[1];

            let result = {};
            const showError = window.location.hash.includes("#/person")
                || window.location.hash.includes("#/login")
                || window.location.hash.includes("#/canvasDocsOrg")
            try {
                if (form) {
                    Data[type]({ url, params, form });
                    return;
                }
                result = await Data[type]({ url, params, form });
                if (type === "export") return console.log(result);
                if (!result.data && showError) message.error("数据异常！")
                if (result.data.status === 100 && showError) {
                    if (window.logout) window.logout();
                    window.go("/");
                    message.error("登陆超时。请重新登陆！")
                }
                if (![100, 200].includes(result.data.status) && showError) {
                    if (result.data.msg && result.data.status !== 100 && typeof result.data.msg === "string") error(result.data.msg)
                    console.error(url);
                    console.error(result.data.msg);
                }
            } catch (error) {
                if (showError) message.error("服务器异常，请稍后再试！");
                console.error(error);
            }

            return result.data;
        })
    );
}